export enum ENpsSurveySource {
  ACA_DOWNLOAD_REPORT = 'ACA-download report',
  BOOKING_CONFIRM = 'myQIMA-booking confirmation',
  DOWNLOAD_INVOICE = 'myQIMA-download invoice',
  DOWNLOAD_REPORT = 'myQIMA-download report',
  PAY_SUCCESS = 'myQIMA-pay success',
}
